import { NotifyHelper } from "../../../helpers/toast";
import { objCrmSurveyFormDefine } from "../../action-types/crm-survey/ICrmSurveyFormActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const crmSurveyFormActions = {
    ...generateActions(objCrmSurveyFormDefine, "CRM_SURVEY_FORM"),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "SELECT_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "SELECT_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objCrmSurveyFormDefine, "CRM_SURVEY_FORM",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
